export default "__VITE_ASSET__bc610367__"